import type { LeagueDisableImpact } from '@/types/league';

/** Disabling needs a confirmation when it affects tournaments or unfinished matches. */
export function hasDisableImpact(impact: LeagueDisableImpact): boolean {
  return impact.tournamentCount > 0 || impact.upcomingMatches > 0 || impact.unresolvedMatches > 0;
}
